<irembogov-cascading-drop-downs
  [isTouched]="formControl.touched"
  [formControl]="formControl"
  [loading]="loading"
  [items]="items"
  [model]="model"
  [field]="field"
  (activeDropDown)="handleActiveDropDown($event)"
  [configs]="processedConfigs"></irembogov-cascading-drop-downs>
